import { render, staticRenderFns } from "./formWawancara.vue?vue&type=template&id=59bfd870&"
import script from "./formWawancara.vue?vue&type=script&lang=js&"
export * from "./formWawancara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports